import { mapGetters } from 'vuex'
import help from '@/utils/help'
import zip from '@/utils/zip'
import { reviewerInvite } from '@/api/reviewer'
import { getUploadConfig } from '@/utils/upload'
import { question } from '@/api/questionnaire'
import { REVIEWER_DECISION } from '@/utils/dict'
import Loading from './loading.dialog'
import customerReviewQuestion from '@/components/question.vue'

const columns = [
  {
    title: '',
    enTitle: 'Order',
    width: 50,
    dataIndex: 'index',
    slot: 'index'
  },
  {
    title: '',
    enTitle: 'File Name',
    width: 230,
    dataIndex: 'name',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Size',
    width: 80,
    dataIndex: 'size',
    slot: 'size'
  },
  {
    title: '',
    enTitle: 'Description',
    width: 320,
    dataIndex: 'description',
    slot: 'description'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 150,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
export default {
  components: { Loading, customerReviewQuestion },
  data() {
    return {
      // 取回数据
      reviewsResponse: {
        journal: {},
        type: {}
      },
      uploadProgress: {
        total: 0,
        current: 0
      },
      loading: false,
      reviews: {
        decisionStatus: '',
        questionList: [],
        authorNotes: '',
        editorNotes: ''
      },
      termList: [],
      rules: {},
      progress: {
        progress: 20,
        status: 'PROCESSING'
      },
      articalStatus: REVIEWER_DECISION,
      showReport: false,
      showReview: false,
      showManuscript: false,
      dataSource: [],
      errArr: [],
      columns,
      pertrial: false // 外编
    }
  },
  mounted() {
    this.getRules()
    this.getData()
    let routeName = this.$route.name
    switch (routeName) {
      // 外编
      case '/reviewers-menu/reviews/pre-trial':
        this.pertrial = true
        break
      case '/reviewers-menu/reviews/reviews-agree':
        this.pertrial = false
        break
      default:
        this.pertrial = false
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      domain: 'getDomain'
    }),
    termList1() {
      return this.articalStatus
    }
  },
  watch: {
    reviewerInvite
  },
  methods: {
    getRules() {
      this.rules = {
        decisionStatus: [
          {
            required: true,
            message: this.LANGUAGE[this.language].noEmpty
          }
        ],
        suggestion: [
          {
            required: true,
            message: this.LANGUAGE[this.language].noEmpty
          }
        ]
      }
    },

    // 获取数据    1432514925514805249
    async getData() {
      // let data = this.$route.params

      let id = this.$route.query.id
      let data = {
        sign: this.$route.query.sign
      }
      const results = await reviewerInvite.query(id, data)
      this.reviewsResponse = results

      this.reviews.questionList = await question.getAll({
        journalId: results.journal.id,
        name: 'REVIEWING'
      })
      this.reviews.questionList.forEach(item => {
        item.questionId = item.id
        item.id = ''
      })
    },

    onChange() {},

    // 文件上传
    async handleUpload(files) {
      const types = [
        'pdf',
        'docx',
        'doc',
        'txt',
        'png',
        'jpg',
        'jpeg',
        'mp4',
        'mp3',
        'html',
        'xml',
        'mov',
        'xls',
        'xlsx',
        'zip',
        'tif',
        'tiff',
        'rtf'
      ]
      if (files.length === 1) {
        const file = files[0]
        let type = file.name.split('.')
        type = type[type.length - 1].toLowerCase()
        if (!types.includes(type)) {
          this.$message.error({
            title: 'Error',
            content: this.LANGUAGE[this.language].isWrongType
          })
          return false
        } else {
          this.addFile(file)
        }
      } else {
        files.forEach(file => {
          let type = file.name.split('.')
          type = type[type.length - 1].toLowerCase()
          if (types.includes(type)) {
            this.addFile(file)
          }
        })
      }

      // const MS = 200
      // const maxSize = file.size / 1024 / 1024 < MS
      // if (!maxSize) {
      //   this.$message.error({
      //     title: 'Error',
      //     content: this.LANGUAGE[this.language].notExceed + MS + 'MB'
      //   })
      //   return false
      // }
    },
    addFile(file) {
      const flag = this.dataSource.some(val => {
        if (file.name === val.name) {
          val = {
            manuscriptId: this.reviewsResponse.manuscriptId,
            sign: this.reviewsResponse.sign,
            name: file.name,
            size: file.size,
            sort: '',
            description: '',
            path: '',
            file: file,
            lastTime: this.$moment()
            // version: ''
          }
          return true
        }
      })
      if (!flag) {
        this.dataSource.push({
          manuscriptId: this.reviewsResponse.manuscriptId,
          sign: this.reviewsResponse.sign,
          name: file.name,
          size: file.size,
          sort: '',
          description: '',
          path: '',
          file: file,
          lastTime: this.$moment()
        })
      }
    },

    // 文件列表
    setSort() {},
    download(item) {
      // const file = this.dataSource[index]
      const file = item
      if (file) {
        const url = file.path
          ? this.domain + '/' + file.path
          : window.URL.createObjectURL(file.file)
        help.download(url, file.name)
      } else {
        // zip.zipFile(this.dataSource, 'author_files.zip')
        zip.zipFile(item, 'author_files.zip')
      }
    },
    del(index) {
      this.$confirm({
        title: 'Are you sure you want to delete this file?',
        content:
          'Please be aware of once this file is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        if (index || index === 0) {
          this.dataSource.splice(index, 1)
        } else {
          this.dataSource = []
        }
        this.$message.success({
          title: 'Success',
          content: 'This file has been deleted!'
        })
      })
    },

    // 提交
    async submit() {
      // const flag = this.$refs['reviews-commit'].validate()
      // this.reviews.score = 6
      this.reviews.questionList.some(item => {
        if (
          item.type === 'MULTIPLE' &&
          item.checkedOptions &&
          item.checkedOptions.length
        ) {
          item.checkedOption = item.checkedOptions.join(';')
        }
      })
      if (!this.reviews.decisionStatus) {
        this.$message.error({
          title: 'Submit failed',
          content: 'Decision cannot be empty'
        })
        return
      }
      if (!this.reviews.revised) {
        this.$message.error({
          title: 'Submit failed',
          content: 'Review the Revised Manuscript cannot be empty'
        })
        return
      }
      if (!this.reviews.authorNotes) {
        this.$message.error({
          title: 'Submit failed',
          content: 'Comments to Author cannot be empty'
        })
        return
      }
      // console.log(this.reviews, '参数')

      const flag = this.reviews.questionList.every(item => {
        if (
          item.required &&
          (item.answer || item.checkedOption || item.checkedOption === 0)
        ) {
          return true
        }
      })
      if (!flag) {
        this.$message.error({
          title: 'Submit failed',
          content: 'questionnaire data cannot be empty'
        })
        return
      }
      // console.log(flag, '问卷是否为空', this.reviews.questionList)

      const path = `publisher/${this.publisherId}/manuscript/${
        this.reviewsResponse.manuscriptId
      }/submit/${help.guid()}`

      this.uploadProgress = {
        current: 0,
        total: this.dataSource.length
      }
      const pro_all = []
      this.loading = true
      this.dataSource.forEach((item, index) => {
        if (!item.path) {
          pro_all[index] = getUploadConfig(item.file, path).then(res => {
            if (res && !res.includes('err:')) {
              this.uploadProgress.current++
            }
            return res
          })
        } else {
          this.uploadProgress.current++
        }
      })
      const reses = await Promise.all(pro_all)
      this.errArr = []
      reses.forEach(item => {
        if (item && item.includes('err:')) {
          this.errArr.push(item.split(':')[1])
        }
      })

      this.dataSource.forEach((item, index) => {
        if (!item.path && reses[index] && !reses[index].includes('err:')) {
          item.path = reses[index]
        }
        item.sort = index
      })

      if (this.errArr.length) {
        this.$message.error(this.LANGUAGE[this.language].uploadFileFail, 5)
        this.uploadProgress = {
          current: 0,
          total: 0
        }
        return
      }

      this.loading = false
      this.parmas = Object.assign(this.reviews, {
        version: this.reviewsResponse.version,
        id: this.$route.query.id,
        sign: this.reviewsResponse.sign,
        questionList: this.reviews.questionList
      })
      this.parmas.reviewerFileList = this.dataSource

      await reviewerInvite.reviewsCommit(this.parmas)

      this.$message.success({
        title: 'Success',
        content: 'Confirm successfully'
      })
      this.$router.push('/reviewers-menu/reviews')
    },
    changeProcess(val) {
      this.reviews.process = val
    },
    togalReport(item, type) {
      // item.showReport == undefined
      //   ? (item.showReport = true)
      //   : (item.showReport = !item.showReport)
      item[type] == undefined ? (item[type] = true) : (item[type] = !item[type])
      this.reviewsResponse.reportList = JSON.parse(
        JSON.stringify(this.reviewsResponse.reportList)
      )
    },
    cancel() {
      this.loading = false
    },
    // 状态切换
    changeStatus(statu) {
      this.reviews.decisionStatus = statu
    },
    changeManuscript(statu) {
      this.reviews.revised = statu
    },
    changeQues(val, item) {
      if (item.type === 'SINGLE') {
        val = val === false || val === true || !val ? 0 : val
        item.checkedOption = val
        this.reviews.questionList = JSON.parse(
          JSON.stringify(this.reviews.questionList)
        )
      } else if (item.type === 'MULTIPLE') {
        val = val === false || val === true || !val ? 0 : val
        if (item.checkedOptions === undefined) {
          item.checkedOptions = []
          item.checkedOptions.push(val)
        } else {
          let index = item.checkedOptions.findIndex(ele => {
            return val === ele
          })
          if (index === -1) {
            item.checkedOptions.push(val)
          } else {
            item.checkedOptions.splice(index, 1)
          }
        }
        // console.log(item.checkedOption, 'aaa')
        this.reviews.questionList = JSON.parse(
          JSON.stringify(this.reviews.questionList)
        )
      }
    }
  }
}
